import Vue from 'vue';
import Vuex from 'vuex';
import addProductStore from './addProduct';
import supplyChainStore from './supplyChain';
import { getAddressSelect, getUserInfo } from './api';

Vue.use(Vuex);

const state = {
    provinceList: [],   //省份，全局请求一次
    userInfoTab: 1,     //个人中心里的tab，1个人信息，2头像修改，3收货地址管理
    userInfo: null,
    productList: [],
};

const mutations = {
    setProvinceList (state, list) {
        state.provinceList = list;
    },
    setUserInfoTab (state, tab) {
        state.userInfoTab = tab;
    },
    setUserInfo (state, userInfo) {
        state.userInfo = userInfo;
    },
    setProductList (state, productList) {
        state.productList = productList;
    },
};

const actions = {
    async getProvinceList ({commit}) {
        return getAddressSelect().then(res => {
            commit('setProvinceList', res.data);
        });
    },
    async getUserInfo ({commit}) {
        return getUserInfo().then(res => {
            commit('setUserInfo', res.data.userinfo);
        });
    },
     async getProducts ({commit}, id) {
        return getProducts(id).then(res => {
            const {navigator_list, goods_list} = res.data;
            commit('setProductList', goods_list);
        });
    }
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        addProductStore,
        supplyChainStore,
    },
});



// WEBPACK FOOTER //
// ./src/stores/index.js